@if (hasPhotos && photos && photos.length > 0) {
  <div class="inline-carousel"
       (touchstart)="onTouchStart($event)"
       (touchend)="onTouchEnd($event)"
  >
    <div class="inline-carousel__frame">
      <app-image
        [src]="currentPhoto?.url ?? ''"
        [alt]="'Photo ' + ((currentPhoto?.id ?? activeIndex + 1))"
        preset="card"
        aspectRatio="4/3"
        [sizes]="'(max-width: 768px) 100vw, 520px'"
        [width]="520"
        [height]="390"
        (click)="openFullscreen()"
      ></app-image>
      <button type="button"
              class="inline-carousel__control inline-carousel__control--prev"
              [disabled]="activeIndex === 0"
              (click)="prev()">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button type="button"
              class="inline-carousel__control inline-carousel__control--next"
              [disabled]="activeIndex >= photos.length - 1"
              (click)="next()">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
      <div class="inline-carousel__count">{{activeIndex + 1}} / {{photos.length}}</div>
    </div>
  </div>
}

<app-carousel
  [open]="fullscreen"
  [photos]="photos"
  [index]="activeIndex"
  (onClose)="closeFullscreen()"
></app-carousel>
